export const companyProfile = {
  name: 'Global',
  tagline:
    'Consultores inmobiliarios y servicios integrales, tu aliado integral en propiedad, leyes y tecnologia',
  phone: '+504 9607-8079',
  whatsapp: '50496078079',
  // email: 'hola@novacasa.hn',
  // address: 'Blvd. Morazan, Tegucigalpa, Francisco Morazan',
  mapLabel: 'Tegucigalpa, Honduras',
};

export const propertyTypesSeed = [
  { id: 1, name: 'Casa', slug: 'casa', description: 'Residencias familiares listas para habitar.' },
  { id: 2, name: 'Apartamento', slug: 'apartamento', description: 'Espacios urbanos modernos y funcionales.' },
  { id: 3, name: 'Terreno', slug: 'terreno', description: 'Lotes con alto potencial de desarrollo.' },
];

export const zonesSeed = [
  { id: 1, name: 'Lomas del Guijarro', city: 'Tegucigalpa', description: 'Zona residencial premium con acceso rapido.' },
  { id: 2, name: 'Palmira', city: 'Tegucigalpa', description: 'Area centrica ideal para inversion y oficinas.' },
  { id: 3, name: 'San Ignacio', city: 'Tegucigalpa', description: 'Entorno tranquilo con excelente conectividad.' },
  { id: 4, name: 'El Trapiche', city: 'Tegucigalpa', description: 'Area en crecimiento para vivienda y comercio.' },
];

export const agentsSeed = [
  {
    id: 1,
    name: 'Daniela Flores',
    role: 'Asesora senior',
    phone: '+504 9944-1100',
    email: 'daniela@novacasa.hn',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=900&q=80',
    specialty: 'Residencial premium',
    status: 'Activo',
  },
  {
    id: 2,
    name: 'Miguel Castillo',
    role: 'Consultor de inversion',
    phone: '+504 9888-2200',
    email: 'miguel@novacasa.hn',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=900&q=80',
    specialty: 'Propiedades para renta y retorno',
    status: 'Activo',
  },
];

export const propertiesSeed = [
  {
    id: 1,
    slug: 'casa-con-jardin-lomas-del-guijarro',
    title: 'Casa con jardin en Lomas del Guijarro',
    operation: 'Venta',
    typeId: 1,
    zoneId: 1,
    agentId: 1,
    price: 325000,
    bedrooms: 4,
    bathrooms: 3.5,
    parking: 2,
    area: 320,
    featured: true,
    active: true,
    address: 'Circuito principal, Lomas del Guijarro',
    description: 'Casa de dos niveles con acabados contemporaneos, jardin privado y terraza social. Ideal para familias que buscan seguridad, iluminacion natural y cercania a colegios y comercios.',
    coverImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
    images: [
      'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1200&q=80',
    ],
  },
  {
    id: 2,
    slug: 'apartamento-ejecutivo-en-palmira',
    title: 'Apartamento ejecutivo en Palmira',
    operation: 'Renta',
    typeId: 2,
    zoneId: 2,
    agentId: 2,
    price: 1800,
    bedrooms: 2,
    bathrooms: 2,
    parking: 2,
    area: 145,
    featured: true,
    active: true,
    address: 'Torre residencial, Palmira',
    description: 'Apartamento con lobby, balcon panoramico, cocina abierta y seguridad 24/7. Pensado para ejecutivos y parejas que quieren vivir cerca del distrito financiero.',
    coverImage: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1200&q=80',
    images: [
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1200&q=80',
    ],
  },
  {
    id: 3,
    slug: 'terreno-estrategico-en-el-trapiche',
    title: 'Terreno estrategico en El Trapiche',
    operation: 'Venta',
    typeId: 3,
    zoneId: 4,
    agentId: 2,
    price: 210000,
    bedrooms: 0,
    bathrooms: 0,
    parking: 0,
    area: 980,
    featured: false,
    active: true,
    address: 'Acceso principal a El Trapiche',
    description: 'Terreno plano con excelente frente y alto potencial para vivienda o desarrollo comercial. Cuenta con acceso a servicios basicos y alta visibilidad.',
    coverImage: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1200&q=80',
    images: [
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1448630360428-65456885c650?auto=format&fit=crop&w=1200&q=80',
    ],
  },
  {
    id: 4,
    slug: 'casa-familiar-en-san-ignacio',
    title: 'Casa familiar en San Ignacio',
    operation: 'Venta',
    typeId: 1,
    zoneId: 3,
    agentId: 1,
    price: 278000,
    bedrooms: 3,
    bathrooms: 2.5,
    parking: 2,
    area: 250,
    featured: false,
    active: false,
    address: 'Boulevard residencial, San Ignacio',
    description: 'Propiedad con amplias areas sociales, estudio independiente y patio con pergola. Actualmente inactiva para publicacion pero disponible para gestion administrativa.',
    coverImage: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1200&q=80',
    images: [
      'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1200&q=80',
    ],
  },
];

export const contactsSeed = [
  {
    id: 1,
    name: 'Ana Pineda',
    email: 'ana.pineda@email.com',
    phone: '+504 9911-3322',
    message: 'Quiero agendar una visita para el apartamento en Palmira.',
    propertyId: 2,
    status: 'Nuevo',
    createdAt: '2026-04-10T10:15:00',
  },
];
